import {
  mdiInformation,
  mdiClose,
  mdiCashMultiple,
  mdiChevronRight,
  mdiChevronLeft,
} from '@mdi/js/mdi'

import tamaraCheckoutOn from './components/tamara-checkout-on.vue'
import tamaraCheckoutOff from './components/tamara-checkout-off.vue'
import checkboxCircle from './components/checkbox-circle.vue'
import infoCircleSolid from './components/info-circle-solid.vue'
import tamaraRadioOn from './components/tamara-radio-on.vue'
import tamaraRadioOff from './components/tamara-radio-off.vue'
import tamaraRadioOnV5 from './components/tamara-radio-on-v5.vue'
import tamaraRadioOffV5 from './components/tamara-radio-off-v5.vue'
import closeCircle from './components/close-circle.vue'
import tamaraCheckboxOnLavender from './components/tamara-checkbox-on-lavender.vue'
import tamaraRadioOnLavender from './components/tamara-radio-on-lavender.vue'
import lavenderRadioOn from './components/lavender-radio-on.vue'
import lavenderRadioOff from './components/lavender-radio-off.vue'

export default {
  tamaraCheckboxOn: {
    component: tamaraCheckoutOn,
  },
  tamaraCheckboxOnLavender: {
    component: tamaraCheckboxOnLavender,
  },
  tamaraCheckoutOff: {
    component: tamaraCheckoutOff,
  },
  tamaraRadioOn: {
    component: tamaraRadioOn,
  },
  tamaraRadioOnLavender: {
    component: tamaraRadioOnLavender,
  },
  tamaraRadioOff: {
    component: tamaraRadioOff,
  },
  lavenderRadioOn: {
    component: lavenderRadioOn,
  },
  lavenderRadioOff: {
    component: lavenderRadioOff,
  },
  tamaraRadioOnV5: {
    component: tamaraRadioOnV5,
  },
  tamaraRadioOffV5: {
    component: tamaraRadioOffV5,
  },
  checkboxCircle: {
    component: checkboxCircle,
  },
  infoCircleSolid: {
    component: infoCircleSolid,
  },
  closeCircle: {
    component: closeCircle,
  },
  info: mdiInformation,
  close: mdiClose,
  cashMultiple: mdiCashMultiple,
  chevronRight: mdiChevronRight,
  chevronLeft: mdiChevronLeft,
}
